import { CSSProperties } from "react";
import { Alert as ChakraAlert } from "@chakra-ui/react";

interface AlertProps {
  title: string;
  intent?: "none" | "success" | "warning" | "danger";
  subtitle?: string;
  style?: CSSProperties;
  className?: string;
}

const intentToStatus = {
  none: "info",
  success: "success",
  // Something the reader should look at before continuing, as opposed to
  // something that already went wrong.
  warning: "warning",
  danger: "error",
} as const;

export function Alert({
  intent = "none",
  title,
  subtitle,
  style,
  className,
}: AlertProps) {
  return (
    <ChakraAlert.Root
      status={intentToStatus[intent]}
      style={style}
      className={className}
    >
      <ChakraAlert.Indicator />
      <ChakraAlert.Content>
        <ChakraAlert.Title>{title}</ChakraAlert.Title>
        {!!subtitle && (
          <ChakraAlert.Description>{subtitle}</ChakraAlert.Description>
        )}
      </ChakraAlert.Content>
    </ChakraAlert.Root>
  );
}
